import { SignInWithWalletMessage } from "@mezo-org/sign-in-with-wallet";
import { ONE_DAY_MS } from "./time";
const SESSION_EXPIRATION_DURATION_MS = 14 * ONE_DAY_MS;
export function createSignInWithWalletMessage(address, nonce, networkFamily, chainId) {
    const { host: domain, origin: uri } = window.location;
    const message = new SignInWithWalletMessage({
        domain,
        address, // if "bitcoin" this should be btc address, not underlaying eth address
        uri,
        nonce,
        issuedAt: new Date().toISOString(),
        expirationTime: new Date(Date.now() + SESSION_EXPIRATION_DURATION_MS).toISOString(),
        version: "1",
        chainId: networkFamily === "evm" ? chainId : undefined,
        networkFamily,
    });
    return message.prepareMessage();
}
//# sourceMappingURL=siww.js.map